import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#F8F8FB" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Comprehensive Metaverse Development Services</h2>
            <p>
              Leverage the full potential of the metaverse with TekRevol's
              specialized development services. Our expert team delivers
              tailored solutions across various domains, ensuring top-notch
              performance and innovation.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build Your Metaverse
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Metaverse Application Development</h4>
                  <p>
                    TekRevol specializes in creating advanced metaverse
                    applications using blockchain, AI, and AR/VR technologies.
                    Our applications are designed for user-friendliness, robust
                    privacy, and automation, ensuring seamless integration into
                    the metaverse ecosystem.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Metaverse NFT Marketplace Development</h4>
                  <p>
                    We build custom NFT marketplaces with secure transaction
                    mechanisms, efficient token integration, and smart contract
                    implementation. Our solutions offer scalable infrastructure
                    and user-centric designs for seamless trading experiences.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Metaverse Game Development</h4>
                  <p>
                    TekRevol develops immersive metaverse games on leading
                    platforms, featuring interactive environments and innovative
                    gameplay mechanics. Our games are designed with stunning
                    graphics and engaging user experiences to captivate
                    audiences.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Metaverse Integration Services</h4>
                  <p>
                    Our integration services ensure the smooth interoperability
                    of metaverse components with existing systems. We enhance
                    functionality across all platforms and devices, ensuring
                    seamless user experiences and operational efficiency.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Metaverse Social Media App Development</h4>
                  <p>
                    We create dynamic social media apps for the metaverse,
                    incorporating real-time interaction features, rich media
                    sharing, and virtual event hosting. Our apps foster
                    community building and enhance social engagement within the
                    metaverse.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
